<fieldset>
  <legend class="group-label fw-bold">Voorkeur belafspraak</legend>
  <rfa-errors [control]="dayControl"></rfa-errors>
  <rfa-errors [control]="timeControl"></rfa-errors>
  <div class="group-container">
    <div class="group-input group-input-medium">
      <label class="group-input-label" [for]="dayControl.id">
        {{ dayControl.options.label }}
      </label>
      <select
        class="form-select"
        [id]="dayControl.id"
        [formControl]="dayControl"
        [wlTrackValueChange]="valueChangeTrackConfig(dayControl)"
      >
        <option selected ngValue="">
          {{ dayControl.options.emptyValueText }}
        </option>
        @for (entry of daysOptions().entries; track entry) {
          <option [ngValue]="entry.value">
            {{ entry.text | date }}
          </option>
        }
      </select>
    </div>
    @if (timesOptions().entries.length > 0) {
      <div class="group-input group-input-medium">
        <label class="group-input-label" [for]="timeControl.id">
          {{ timeControl.options.label }}
        </label>
        <select
          class="form-select"
          [id]="timeControl.id"
          [formControl]="timeControl"
          [wlTrackValueChange]="valueChangeTrackConfig(timeControl)"
        >
          <option selected ngValue="">
            {{ timeControl.options.emptyValueText }}
          </option>
          @for (entry of timesOptions().entries; track entry) {
            <option [ngValue]="entry.value">
              {{ entry.text }}
            </option>
          }
        </select>
      </div>
    }
  </div>
</fieldset>
